import { useState } from "react";

/** A monospace value with a copy button — used for the invoice address, not billing logic. */
export function CopyField({ value, label }: { value: string; label?: string }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard API unavailable (permissions, insecure context) — the value is still selectable/visible.
    }
  }

  return (
    <div>
      {label && <p className="text-xs text-muted mb-1">{label}</p>}
      <div className="flex items-stretch gap-2">
        <p className="flex-1 min-w-0 font-mono text-xs break-all bg-ink-950 border border-ink-700 rounded-md px-2.5 py-2">
          {value}
        </p>
        <button
          type="button"
          onClick={copy}
          className="shrink-0 px-3 rounded-md border border-ink-700 text-xs text-muted hover:border-ledger-500 hover:text-paper transition-colors"
        >
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
}
